import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { getSize, getColor, RichTextEditor } from '@lib/common';
import styled from '@xstyled/styled-components';
import { Radio, Tooltip } from 'antd';
import Image from 'next/image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledLayout = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  gap: ", ";\n  width: 100%;\n"])), getSize('padding4'));
var StyledRadioWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  margin-top: ", ";\n"])), getSize('padding8'), getSize('padding8'));
var StyledRadio = styled(Radio)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  align-self: flex-start;\n\n  .ant-radio {\n    top: 0 !important;\n  }\n\n  .ant-radio-inner {\n    width: 18px;\n    height: 18px;\n    border: 1px solid grey;\n  }\n\n  .ant-radio-checked .ant-radio-inner {\n    border-color: ", ";\n  }\n\n  .ant-radio-checked .ant-radio-inner::after {\n    background-color: ", ";\n  }\n"])), getColor('fillIntActive'), getColor('fillIntActive'));
var StyledActionButtonWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  flex-shrink: 0;\n\n  &:hover {\n    background-color: #f8fafc;\n    border-color: #1a5aff;\n  }\n"])), getSize('padding4'));
var StyledAnswerEditorWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex: 1;\n\n  .tiptap {\n    background-color: white !important;\n  }\n"])));
export var AnswerItem = function AnswerItem(_ref) {
  var answer = _ref.answer,
      isCorrectAnswer = _ref.isCorrectAnswer,
      onUpdateAnswer = _ref.onUpdateAnswer,
      onUpdateCorrectAnswer = _ref.onUpdateCorrectAnswer,
      onDelete = _ref.onDelete,
      onAddImage = _ref.onAddImage,
      editorRef = _ref.editorRef,
      editorLabels = _ref.editorLabels,
      singleChoiceLabel = _ref.singleChoiceLabel;
  return /*#__PURE__*/_jsxs(StyledLayout, {
    children: [/*#__PURE__*/_jsx(StyledRadioWrapper, {
      children: /*#__PURE__*/_jsx(StyledRadio, {
        checked: isCorrectAnswer,
        onChange: onUpdateCorrectAnswer
      })
    }), /*#__PURE__*/_jsx(StyledAnswerEditorWrapper, {
      children: /*#__PURE__*/_jsx(RichTextEditor, {
        ref: editorRef,
        content: answer.description || '',
        onChange: onUpdateAnswer,
        placeholder: singleChoiceLabel === null || singleChoiceLabel === void 0 ? void 0 : singleChoiceLabel.answerPlaceholder,
        autoSave: true,
        addImage: onAddImage,
        editorLabels: editorLabels
      })
    }), onDelete && /*#__PURE__*/_jsx(Tooltip, {
      title: singleChoiceLabel === null || singleChoiceLabel === void 0 ? void 0 : singleChoiceLabel.deleteAnswer,
      placement: "bottom",
      children: /*#__PURE__*/_jsx(StyledActionButtonWrapper, {
        onClick: onDelete,
        children: /*#__PURE__*/_jsx(Image, {
          src: "/icons/delete.svg",
          width: 14,
          height: 14,
          alt: "delete"
        })
      })
    })]
  });
};